/**
 * Card Links API client.
 *
 * Wraps GET /api/cards/:cardId/links — see card-links.ts in the gateway.
 *
 * Cookies (JWT) flow through automatically because apiJson uses
 * `credentials: 'include'`.
 *
 * Note on URL prefix: apiJson already prepends `VITE_API_BASE_URL`
 * which defaults to `/api`. Pass paths WITHOUT the `/api/` prefix
 * (e.g. `/cards/${cardId}/links`) — this was the pitfall M-X5 caught
 * in `explorer.ts`.
 */
import { apiJson } from './client';

export interface CardLink {
  url: string;
  source: 'user' | 'agent' | 'system';
  sessionId: string;
  messageId: string;
  createdAt: string;
}

export interface CardLinksResponse {
  links: CardLink[];
  truncated: boolean;
}

export const cardLinksApi = {
  list(cardId: string): Promise<CardLinksResponse> {
    return apiJson<CardLinksResponse>(`/cards/${cardId}/links`);
  },
};

export const cardLinksKeys = {
  all: ['card-links'] as const,
  forCard: (cardId: string) => [...cardLinksKeys.all, cardId] as const,
};
